<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Submit'"
  >
    <template slot="header">
      <span>Add Part Pick List Item</span>
    </template>
    <template slot="body">
      <v-row v-if="item">
        <v-col>
          <v-row>
            <v-col
              class="pb-0"
            >
              <v-autocomplete
                v-model="item.inventory_tag"
                label="QR Code"
                :items="qrCodes"
                :item-text="item => `${item.inventory_tag} - ${item.item_full_name}`"
                item-value="inventory_tag"
                clearable
                :single-select="false"
                :loading="loadingQrCode"
                :rules="[(v) => !!v || 'QR Code is required']"
              >
                <!-- eslint-disable-next-line vue/no-template-shadow -->
                <template #selection="{ item }">
                  <span><span style="font-weight: bold;">{{ item.inventory_tag ? `${item.inventory_tag}` : '' }}</span> - {{ item.item_full_name ? item.item_full_name : '' }}</span>
                </template>
                <!-- eslint-disable-next-line vue/no-template-shadow -->
                <template #item="{ item }">
                  <span><span style="font-weight: bold;">{{ item.inventory_tag ? `${item.inventory_tag}` : '' }}</span> - {{ item.item_full_name ? item.item_full_name : '' }}</span>
                </template>
                <template #label>
                  QR Code<RedAsterisk />
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="6">
              <span style="font-size: 16px; color: #000000;">Quantity On Hand: {{ quantityOnHand }}</span>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="item.quantity_required"
                :rules="[(v) => !!v && item.quantity_required <= parseInt(quantityOnHand) || 'Quantity Required is required and should not exceed quantity on hand']"
                type="number"
              >
                <template #label>
                  Quantity Required<RedAsterisk />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      inventory_tag: null,
      quantity_required: null,
    },
    loadingQrCode: false,
    qrCodes: [],
    inventoryClassIdParts: 11,
    quantityOnHand: 0,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {
    // eslint-disable-next-line func-names
    'item.inventory_tag': function (val) {
      const item = this.qrCodes.find((x) => x.inventory_tag === val);
      if (item) {
        this.quantityOnHand = item.quantity_on_hand;
      }
    },

  },
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async submit() {
      this.$emit('success', { ...this.item });
      return true;
    },

    async open(item) {
      this.$refs.dialogBox.open();
      this.quantityOnHand = 0;
      const res = await this.getQrCodes();
      if (!res) return;
      this.item = { ...item };
    },

    async getQrCodes() {
      this.loadingQrCode = true;
      const readModel = {
        filters:
        {
          inventory_class_id: this.inventoryClassIdParts,
        },
      };
      const res = await this.$api.inventoryTag.readData(readModel);

      const cancelCode = 3001;
      if (res === cancelCode) return false;
      this.loadingQrCode = false;
      if (!res || !res.data || res.data.length === 0) {
        this.qrCodes = [];
        return false;
      }
      this.qrCodes = res.data;
      return true;
    },
  },
};
</script>
